import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";

const UnitInformation = ({ device, deviceLoading, handleRefresh }) => {
console.log(device,"device")
  const [unitName, setUnitName] = useState(device?.name || "");
  const [isActive, setIsActive] = useState(
    device?.isActive ? "active" : "standby"
  );
  const [isUpdating, setIsUpdating] = useState(false);

  // Update local state when prop changes
  useEffect(() => {
    if (device) {
      setUnitName(device.name || "");
      setIsActive(device.isActive ? "active" : "standby");
    }
  }, [device?.id]);

  const handleUpdate = async () => {
    if (!device?.id || !unitName.trim()) return;

    setIsUpdating(true);
    try {
      const payload = {
        id: device.id,
        name: unitName,
        isActive: isActive === "active",
        UI_Description: `${getUIDescription()}\n  "Update Button of the Unit Information & Status"`, 
      };

      const response = await axios.put(
        `${process.env.REACT_APP_API_GATEAWAY}/devices?id=${device.id}`,
        payload
      );

      if (response.data) {
        toast.success("✅ Unit updated successfully!");
        handleRefresh();
      }
    } catch (error) {
      console.error("Error updating unit:", error);
      toast.error("❌ Error updating unit!");
    } finally {
      setIsUpdating(false);
    }
  };

  // --- No device selected ---
  if (!device && !deviceLoading) {
    return (
      <div className="flex items-center justify-center h-full bg-slate-900 rounded-xl">
        <p className="text-slate-400">No device selected</p>
      </div>
    );
  }

  return (
    <div className="relative bg-[#293445] text-white rounded-xl shadow p-4 border border-[#2E3B4C] flex flex-col gap-4">

      <h2 className="text-lg font-semibold text-white">
        Unit Information & Status
      </h2>

      <div className="flex flex-row items-center gap-3 w-full flex-wrap md:flex-nowrap">
        {/* Modem Serial Number */}
        <div className="flex flex-col flex-1 min-w-[180px]">
          <label className="text-xs text-slate-400 mb-1">Modem Serial Number</label>
          <input
            type="text"
            value={device?.id || ""}
            disabled
            className="bg-[#2E3B4C] text-slate-400 border border-[#3D4A5C] rounded-md px-2 py-1.5 w-full text-sm cursor-not-allowed"
          />
        </div>

        {/* Unit Name */}
        <div className="flex flex-col flex-1 min-w-[180px]">
          <label className="text-xs text-slate-400 mb-1">Unit Name</label>
          <input
            type="text"
            value={unitName}
            onChange={(e) => setUnitName(e.target.value)}
            className="bg-[#2E3B4C] text-white border border-blue-400 rounded-md px-2 py-1.5 w-full text-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
          />
        </div>

        {/* Status */}
        <div className="flex flex-col flex-1 min-w-[180px]">
          <label className="text-xs text-slate-400 mb-1">Status</label>
          <select
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
            className="bg-[#2E3B4C] text-white border border-blue-400 rounded-md px-2 py-1.5 w-full text-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
          >
            <option value="active">Active</option>
            <option value="standby">Standby</option>
          </select>
        </div>

        {/* Update Button */}
        <div className="flex flex-col flex-1 mt-5 min-w-[180px]">
          <button
            onClick={handleUpdate}
            disabled={isUpdating || !unitName.trim()}

            className={`w-full px-6 py-2 rounded-md text-sm font-medium transition-colors ${isUpdating || !unitName.trim()
              ? "bg-[#3A4658] text-slate-500 cursor-not-allowed"
              : "bg-blue-400 hover:bg-blue-600 text-black"
              }`}

          >
            {isUpdating ? "Updating..." : "Update Unit"}
          </button>
        </div>
      </div>

      {/* --- Overlay Loading Spinner --- */}
      {(isUpdating) && (
        <div className="absolute inset-0 bg-black/50 backdrop-blur-sm rounded-xl flex flex-col items-center justify-center z-10">
          <div className="w-12 h-12 border-4 border-gray-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-white mt-4 font-medium">
            {isUpdating && "Updating unit..."}
          </p>
        </div>
      )}

    </div>
  );
};

export default UnitInformation;
